import { useState, useEffect } from 'react';
import './MarketTicker.css';

const STOCKS = [
  { symbol: '%5ENSEI',     label: 'NIFTY 50'   },
  { symbol: '%5EBSESN',    label: 'SENSEX'     },
  { symbol: '%5ENSEBANK',  label: 'BANK NIFTY' },
  { symbol: 'RELIANCE.NS', label: 'RELIANCE'   },
  { symbol: 'TCS.NS',      label: 'TCS'        },
  { symbol: 'HDFCBANK.NS', label: 'HDFC BANK'  },
  { symbol: 'INFY.NS',     label: 'INFOSYS'    },
  { symbol: 'SBIN.NS',     label: 'SBIN'       },
];

function MarketTicker() {
  const [items, setItems]     = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      // ── Stocks via your own Vercel proxy ─────────────────────────────
      const stockItems = [];
      try {
        const res    = await fetch('/api/stocks');
        const data   = await res.json();
        const quotes = data?.quoteResponse?.result || [];

        STOCKS.forEach(s => {
          const decoded = s.symbol.replace('%5E', '^');
          const quote   = quotes.find(q => q.symbol === decoded);
          const price   = quote?.regularMarketPrice;
          const pct     = quote?.regularMarketChangePercent;
          const change  = quote?.regularMarketChange;

          if (price != null) {
            stockItems.push({
              label:     s.label,
              price:     price.toLocaleString('en-IN', { maximumFractionDigits: 2 }),
              changePct: pct != null ? Math.abs(pct).toFixed(2) : '0.00',
              up:        change != null ? change >= 0 : true,
            });
          }
        });
      } catch (e) {
        console.warn('Stock fetch failed:', e);
      }

      // ── Crypto via CoinGecko — no proxy needed ────────────────────────
      const cryptoItems = [];
      try {
        const cgRes  = await fetch(
          'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin,ethereum,solana&vs_currencies=inr&include_24hr_change=true',
          { signal: AbortSignal.timeout(6000) }
        );
        const cgData = await cgRes.json();

        [
          { id: 'bitcoin',  label: '₿ BTC' },
          { id: 'ethereum', label: 'Ξ ETH' },
          { id: 'solana',   label: '◎ SOL' },
        ].forEach(c => {
          const d   = cgData?.[c.id];
          const pct = d?.inr_24h_change;
          if (d?.inr != null) {
            cryptoItems.push({
              label:     c.label,
              price:     `₹${Math.round(d.inr).toLocaleString('en-IN')}`,
              changePct: pct != null ? Math.abs(pct).toFixed(2) : '0.00',
              up:        pct != null ? pct >= 0 : true,
            });
          }
        });
      } catch (e) {
        console.warn('Crypto fetch failed:', e);
      }

      const merged = [...stockItems, ...cryptoItems];
      if (merged.length > 0) setItems(merged);
      setLoading(false);

    } catch (err) {
      console.error('Ticker error:', err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const id = setInterval(fetchData, 30000);
    return () => clearInterval(id);
  }, []);

  const display = items.length ? [...items, ...items] : [];

  return (
    <div className="ticker-bar">
      <div className="ticker-label">
        <span className="ticker-live-dot"></span>
        LIVE
      </div>

      <div className="ticker-track-wrap">
        {loading ? (
          <div className="ticker-loading">Fetching market data...</div>
        ) : display.length === 0 ? (
          <div className="ticker-loading">Market data unavailable</div>
        ) : (
          <div className="ticker-track">
            {display.map((item, i) => (
              <div className="ticker-item" key={i}>
                <span className="ticker-name">{item.label}</span>
                <span className="ticker-price">{item.price}</span>
                <span className={`ticker-change ${item.up ? 'up' : 'down'}`}>
                  {item.up ? '▲' : '▼'} {item.changePct}%
                </span>
                <span className="ticker-sep">|</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default MarketTicker;